import $ from 'jquery';

$('.about-history-item__text').click(function () {
    const historyItem = $(this).parents('.about-history-item');
    if (historyItem.hasClass('about-history-item--active')) {
        historyItem.removeClass('about-history-item--active');
    } else {
        historyItem.addClass('about-history-item--active');
        historyItem.siblings('.about-history-item').removeClass('about-history-item--active');
    }
});
